const HUD_SUBSIDY_CODES = {
  SECTION_8: '1',
  RENT_SUPPLEMENT: '2',
  RAP: '3',
  // SECTION_236 is the *secondary* code: the tenant receives Section 8, RAP or
  // Rent Supplement and lives in a 236 property. SECTION_236_PRIMARY is the
  // property's own program, and the only one that means "no assistance".
  // Floor plan hudCode uses primary codes.
  SECTION_236: 'S',
  SECTION_236_PRIMARY: '4',
  BMIR: 'B',
  // BMIR_PRIMARY is the property's own BMIR program. BMIR ('B') is the secondary marker.
  BMIR_PRIMARY: '5',
  '811_PRA_DEMO': '6',
  SECTION_202_PRAC: '7',
  SECTION_811_PRAC: '8',
  MARKET_RENT: '0',
  SECTION_202_162: '9',
};

export default HUD_SUBSIDY_CODES;
